<template>
  <div class="selected-seats">
    <div class="selected-seats__section">
      <span class="selected-seats__label">
        {{ $t('travelPlanner.seat.selectedSeatsOutbound') }}
      </span>
      <span
        v-if="outboundSeats.length"
        class="selected-seats__numbers"
      >
        {{ formatSeats(outboundSeats) }}
      </span>
      <span
        v-else
        class="selected-seats__numbers"
      >
        --
      </span>
    </div>
    <div
      v-if="hasInboundTrip"
      class="selected-seats__section"
    >
      <span class="selected-seats__label">
        {{ $t('travelPlanner.seat.selectedSeatsInbound') }}
      </span>
      <span
        v-if="inboundSeats.length"
        class="selected-seats__numbers"
      >
        {{ formatSeats(inboundSeats) }}
      </span>
      <span
        v-else
        class="selected-seats__numbers"
      >
        --
      </span>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import type { SelectedSeat } from '@/types/seatTypes'

  export default defineComponent({
    name: 'SelectedSeatsDisplay',
    props: {
      outboundSeats: {
        type: Array as PropType<SelectedSeat[]>,
        required: true,
      },
      inboundSeats: {
        type: Array as PropType<SelectedSeat[]>,
        required: true,
      },
      hasInboundTrip: {
        type: Boolean,
        required: true,
      },
    },
    setup(props) {
      const formatSeats = (seats: SelectedSeat[]) => {
        return seats.map((seat) => seat.seat_number).join(', ')
      }

      return {
        formatSeats,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .selected-seats {
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 100%;
    margin-bottom: rem(4);
    padding-bottom: rem(4);
    border-bottom: 1px solid #bdc0d6;

    @media (min-width: $breakpoint-sm) {
      flex-grow: 1;
      width: auto;
      border: none;
    }

    @media (min-width: $breakpoint-lg) {
      flex-direction: row;
    }

    &__section {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: rem(4);
      white-space: nowrap;
      color: $clr-text;

      @media (min-width: $breakpoint-lg) {
        flex-direction: column;
        margin-right: 1.5rem;
        align-items: flex-start;
      }
    }

    &__label {
      @include body-large;
    }

    &__numbers {
      @include title-medium;
      margin: 0 0 0 0.5rem;

      @media (min-width: $breakpoint-lg) {
        margin: 0.5rem 0 0 0;
        @include title-large;
      }
    }
  }
</style>
